export const applyRowDataMapper =
  <TRowData, TReturnedRow>(mapper: (arg: TRowData) => TReturnedRow) =>
    (arr: TRowData[] | undefined): TReturnedRow[] => {
      if (!arr) {
        return []
      }

      return arr.map(mapper)
    }
